<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('nursing:page')">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="预约项目">
                <a-input v-model="queryParam.itemName" allow-clear placeholder="请输入预约项目" />
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="预约人">
                <a-input v-model="queryParam.patientname" allow-clear placeholder="请输入预约人" />
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="护理人员">
                <a-input v-model="queryParam.nuresName" allow-clear placeholder="请输入护理人员" />
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="日期">
                <a-range-picker @change="handlDate" />
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="预约状态">
                <a-select v-model="queryParam.status" placeholder="请选择预约状态" :options="orderState" />
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = { pageNo: 1, pageSize: 10, }">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>

    <a-card :bordered="false">
      <s-table ref="table" :columns="columns" :data="loadData" :alert="options.alert" :rowKey="(record) => record.id" :rowSelection="options.rowSelection">
        <template class="table-operator" slot="operator" v-if="hasPerm('nursing:add')">
          <!-- <a-button type="primary" v-if="hasPerm('nursing:add')" icon="plus" @click="$refs.addForm.add()">新增问诊订单管理</a-button>
          <a-button type="danger" :disabled="selectedRowKeys.length < 1" v-if="hasPerm('nursing:delete')" @click="batchDelete"><a-icon type="delete"/>批量删除</a-button> -->
          <!-- <x-down v-if="hasPerm('nursing:export')" ref="batchExport" @batchExport="batchExport" /> -->
        </template>

        <span slot="consumable" slot-scope="text, record">
          {{ record.consumable == 0 ? '无' : record.consumable == 1 ? '普通' : record.consumable == 2 ? '高级' : '' }}
        </span>

        <span slot="totalPrice" slot-scope="text, record">
          {{ record.totalPrice != '' || record.totalPrice != null ||record.totalPrice != undefined ?( record.totalPrice / 100).toFixed(2) : ''  }}
        </span> totalPrice

        <a slot="status" slot-scope="text, record">
          {{ record.status == 0 ? '待支付' : (record.status == 1 && record.nurse_status != 4 ) ? '已预约' : record.status == 2 ? '已完成' : record.status == 3 ?'已取消' :
          record.status == 4 ? '已上门' : (record.status == 1 && record.nurse_status == 4 ) ? '已预约,已接单': '' }}
        </a>

        <span slot="action" slot-scope="text, record">
          <a @click="$refs.addForm.add(record)" style="margin-right: 10px;">详情</a>

          <a-popconfirm v-if="record.status == 1  && record.nurse_status != 4" placement="topRight" title="接单后患者将不能取消订单并退款，确认接单？"
                        @confirm="() => databaseInfoReceivingOrder(record)"
          >
            <a>确认接单</a>
          </a-popconfirm>

          <a-popconfirm v-if="record.status == 1 && record.nurse_status == 4" placement="topRight" title="是否确认撤销接单？" @confirm="() => databaseInfocancelOrder(record)">
            <a>撤销接单</a>
          </a-popconfirm>
          <!-- <a @click="isfinish(record)" v-if="record.status == 1">完成情况</a> -->
        </span>
      </s-table>

      <view-detial ref="addForm" @ok="handleOk" />
      <edit-form ref="editForm" @ok="handleOk" />

      <a-modal title="完成情况" :width="900" :visible="visible" @cancel="handleCancel">
        <template #footer>
          <a-button type="primary" :loading="confirmLoading" @click="finish">提交</a-button>
          <a-button style="margin-left: 8px" @click="handleCancel">取消</a-button>
        </template>

        <a-form :form="form">
          <a-row :gutter="24">
            <a-col :md="12">
              <a-form-item label="完成情况" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-checkbox v-model="checked">已完成评估工作</a-checkbox>
              </a-form-item>
            </a-col>
            <a-col :md="12">
              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="24">
            <a-col :md="12">
              <a-form-item label="评估医生" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="form.deptId" placeholder="请选择科室单位" :options="dept"></a-select>
              </a-form-item>
            </a-col>
            <a-col :md="12">
              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="form.userId" placeholder="请选择医生姓名" :options="person"></a-select>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="24">
            <a-col :md="12">
              <a-form-item label="评估日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <!-- <a-input v-model="form.cardNo" allow-clear placeholder="请输入日期" /> -->
                <a-date-picker style="width:330px" @change="changeDate" />
              </a-form-item>
            </a-col>
            <a-col :md="12">
              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-time-picker style="width:330px" @change="changeTime" format="HH:mm" />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="24">
            <a-col :md="24" style="padding-left:9px">
              <a-form-item label="情况说明" :labelCol="{xs: { span: 24 },sm: { span: 2 }}" :wrapperCol="{xs: { span: 24 },sm: { span: 20 }}">
                <a-textarea v-model="form.remark" showCount :rows="6" placeholder="请输入擅长" />
              </a-form-item>
            </a-col>
          </a-row>

        </a-form>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
  import {STable, XDown} from '@/components'
  import moment from 'moment'

  import {nursingPage, nursingUpdate, nursingDept, nursingDoct, whetherAcceptOrder} from '@/api/modular/interhospital/nursing/nursingMange'
  import viewDetial from './viewDetial.vue'
  import editForm from './editForm.vue'

  export default {
    components: {
      STable,
      viewDetial,
      editForm,
      XDown,
    },

    data() {
      return {
        checked: false,
        labelCol: {xs: {span: 24}, sm: {span: 4}},
        labelCol_two: {xs: {span: 24}, sm: {span: 2}},
        wrapperCol: {xs: {span: 24}, sm: {span: 19}},
        form: {},
        visible: false,
        confirmLoading: false,
        Loading: false,
        dept: [
          {label: '内科', value: '1'},
          {label: '外科', value: '2'}
        ],
        person: [
          {label: '刘哈哈', value: '1'
          },
          {label: '王哈哈', value: '2'}
        ],
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          // pageNo: 1,
          // pageSize: 10,
        },
        // 表头
        columns: [
          {title: '预约人', align: 'center', dataIndex: 'patientname'},
          {title: '预约项目名称', align: 'center', dataIndex: 'itemName'},
          {title: '护理人员', align: 'center', dataIndex: 'nureName',},
          {
            title: '耗材包', align: 'center', dataIndex: 'consumable',
            scopedSlots: {customRender: 'consumable'},
          },
          {
            title: '金额（元）', align: 'center', dataIndex: 'totalPrice',
            scopedSlots: {customRender: 'totalPrice'},
          },
          {title: '提交时间', align: 'center', dataIndex: 'create_time'},
          // {title: '上门时间', align: 'center', dataIndex: 'door_time'},
          {title: '完成时间', align: 'center', dataIndex: 'finish_time'},
          {
            title: '状态', align: 'center', dataIndex: 'status',
            scopedSlots: {customRender: 'status'},
          },
        ],
        treatType: [
          {value: '0', label: '换药'},
          {value: '1', label: '导尿'},
          {value: '2', label: '静脉取血'},
        ],
        orderState: [
          {value: '0', label: '待支付'},
          {value: '1', label: '已预约'},
          {value: '2', label: '已完成'},
          {value: '4', label: '已上门'},
          {value: '3', label: '已取消'},
        ],
        tstyle: {'padding-bottom': '0px', 'margin-bottom': '10px'},
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          // return nursingPage(this.queryParam).then((res) => {
          //   // console.log('res=====',res);
          //   return res.data
          // })
          return new Promise(async (resolve, reject) => {
            console.log('这个值======', parameter, this.switchingDate())
            const res = await nursingPage(Object.assign(parameter, this.switchingDate()));
            resolve(res.data)
          });
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: {
            show: true, clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        },
        recordList: {},
      }
    },

    created() {
      // if (this.hasPerm('nursing:edit') || this.hasPerm('nursing:delete')) {
      this.columns.push({
        title: '操作', width: '150px', dataIndex: 'action',
        scopedSlots: {customRender: 'action'}
      })
      // }

    },
    watch: {
      'form.deptId'(nval) {
        console.log(nval);
        this.person = [];
        let parmas = {
          deptId: nval
        }
        nursingDoct(parmas).then(res => {
          // console.log(res);
          if (res.code == 200) {
            res.data.map(item => {
              this.person.push({
                label: item.realName,
                value: item.userId
              })
            })
          }
        })
      }
    },

    methods: {
      moment,

      /**
       * 查询参数组装
       */
      switchingDate() {
        const queryParamverifytime = this.queryParam.verifytimeDate
        if (queryParamverifytime != null) {
          this.queryParam.verifytime = moment(queryParamverifytime).format('YYYY-MM-DD')
          if (queryParamverifytime.length < 1) {
            delete this.queryParam.verifytime
          }
        }
        const obj = JSON.parse(JSON.stringify(this.queryParam))
        return obj
      },
      // 关闭完成情况弹框
      handleCancel() {
        this.visible = false;
      },

      // 提交时间
      handlDate(date, dateString) {
        this.queryParam.searchBeginTime = dateString[0];
        this.queryParam.searchEndTime = dateString[1];
      },

      handleOk() {
        this.$refs.table.refresh()
      },

      onSelectChange(selectedRowKeys, selectedRows) {
        console.log(selectedRowKeys, selectedRows)
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },

      databaseInfoReceivingOrder(record) {
        this.Loading = true
        console.log('databaseInfoReceivingOrder', record)
        let parmas = {
          id: record.id,
          nurseStatus: "4"
        }

        whetherAcceptOrder(parmas).then((res) => {
          if (res.success) {
            this.$message.success('接单成功')
            this.$refs.table.refresh()
          } else {
            this.$message.error('接单失败：' + res.message)
          }
        }).catch((err) => {
          this.$message.error('接单错误：' + err.message)
        }).finally((res) => {
          this.Loading = false
        })
      },

      databaseInfocancelOrder(record) {
        this.Loading = true
        console.log('databaseInfoReceivingOrder', record)
        let parmas = {
          id: record.id,
          nurseStatus: "5"
        }

        whetherAcceptOrder(parmas).then((res) => {
          if (res.success) {
            this.$message.success('撤销成功')
            this.$refs.table.refresh()
          } else {
            this.$message.error('撤销失败：' + res.message)
          }
        }).catch((err) => {
          this.$message.error('撤销错误：' + err.message)
        }).finally((res) => {
          this.Loading = false
        })
      },

      // 打开完成情况
      isfinish(record) {
        this.recordList = record;
        this.visible = true;

        nursingDept().then(res => {
          console.log(res)

          this.dept = [];
          res.data.map(item => {
            this.dept.push({
              label: item.deptDesc,
              value: item.deptId
            })
          })
        })

      },

      // 日期框
      changeDate(data, dateString) {
        console.log(dateString);
        this.form.date = dateString;
      },
      // 时间框
      changeTime(date, dateString) {
        console.log(dateString);
        this.form.time = dateString;
      },

      // 提交完成情况
      finish() {
        this.confirmLoading = true;

        if (!this.checked) {
          this.$message.info('请选择完成情况');
          return;
        }
        let params = {
          id: this.recordList.id,
          remark: this.form.remark, // 情况说明
          planTime: this.form.date + ' ' + this.form.time, //预约时间
          status: this.checked ? 2 : '',
          deptId: this.form.deptId,
          userId: this.form.userId,
        };

        nursingUpdate(params).then(res => {
          this.confirmLoading = false;
          if (res.code == 200) {
            this.visible = false;
            this.$message.success('提交成功');
            this.handleOk();
          } else {
            this.$message.error('提交失败')
          }
        })
      },
    }
  }
</script>

<style lang="less">
  .table-operator {
    margin-bottom: 18px;
  }

  button {
    margin-right: 8px;
  }
</style>
